export default "__VITE_ASSET__B2izwIO9__"